"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var axios_1 = __importDefault(require("axios"));
var DetailDataSingleLabel_1 = __importDefault(require("../../components/contract_form/DetailDataSingleLabel"));
var Torihikisaki_1 = __importDefault(require("../../components/sales_force/Torihikisaki"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var apply_service_const_1 = __importDefault(require("../../../common/src/constrains/contract_form/apply_service_const"));
var TorihikisakiSekininsyaApply_1 = __importDefault(require("../../components/sales_force/TorihikisakiSekininsyaApply"));
var TorihikisakiSekininsyaTanto_1 = __importDefault(require("../../components/sales_force/TorihikisakiSekininsyaTanto"));
var entity_1 = require("../../../common/src/types/model/sales_force_info/entity");
var SimpleDialog_1 = __importDefault(require("../../components/globals/SimpleDialog"));
var csv_output_module_factory_1 = __importDefault(require("../../utils/sales_force/csv_output_module_factory"));
var Loading_1 = __importDefault(require("../../components/globals/Loading"));
var dayjs_1 = __importDefault(require("dayjs"));
var apply_service_utils_1 = __importDefault(require("../../../common/src/constrains/contract_form/apply_service_utils"));
var MoveSalesForceButton_1 = __importDefault(require("../../components/sales_force/MoveSalesForceButton"));
var PriceBookSelect_1 = __importDefault(require("../../components/sales_force/PriceBookSelect"));
var ApplicationDetails_1 = __importDefault(require("../../components/sales_force/ApplicationDetails"));
var OpportunityKobetu_1 = __importDefault(require("../../components/sales_force/OpportunityKobetu"));
var OpportunityOralCare_1 = __importDefault(require("../../components/sales_force/OpportunityOralCare"));
var OpportunityUpgrade_1 = __importDefault(require("../../components/sales_force/OpportunityUpgrade"));
var OpportunityEntry_1 = __importDefault(require("../../components/sales_force/OpportunityEntry"));
var OpportunityBasic_1 = __importDefault(require("../../components/sales_force/OpportunityBasic"));
var OpportunityMedium_1 = __importDefault(require("../../components/sales_force/OpportunityMedium"));
var OpportunityStandard_1 = __importDefault(require("../../components/sales_force/OpportunityStandard"));
var OpportunityProfessional_1 = __importDefault(require("../../components/sales_force/OpportunityProfessional"));
var OpportunityUpgradeToStandard_1 = __importDefault(require("../../components/sales_force/OpportunityUpgradeToStandard"));
var OpportunityAdditionalTablet_1 = __importDefault(require("../../components/sales_force/OpportunityAdditionalTablet"));
var OpportunityMotionAi_1 = __importDefault(require("../../components/sales_force/OpportunityMotionAi"));
var OpportunityOldStandard_1 = __importDefault(require("../../components/sales_force/OpportunityOldStandard"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var ReflectSalesForce = /** @class */ (function (_super) {
    __extends(ReflectSalesForce, _super);
    function ReflectSalesForce() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tab = null;
        _this.documentData = {
            documentId: '',
            applyInfoApplyService: [],
            officeInfoZip1: '',
            officeInfoZip2: '',
            officeInfoAddress1: '',
            officeInfoAddress2: '',
            officeInfoAddress3: '',
            requestInfoZip1: '',
            requestInfoZip2: '',
            requestInfoAddress1: '',
            requestInfoAddress2: '',
            requestInfoAddress3: '',
            applyInfoInputNumber: '',
            officeInfoRequestPersonLastName: '',
            officeInfoRequestPersonFirstName: ''
        };
        _this.salesForceInfo = {
            documentId: '',
            lastUpdateUser: '',
            additionalTabletRegisterObj: [],
            firstTabletRegister: '1',
            additionalTabletTempOpportunityId: '',
            entryPrimaryEkycIdFlg: '',
            basicPrimaryEkycIdFlg: '',
            oldStandardPrimaryEkycIdFlg: '',
            mediumPrimaryEkycIdFlg: '',
            standardPrimaryEkycIdFlg: '',
            professionalPrimaryEkycIdFlg: '',
            upgradePrimaryEkycIdFlg: ''
        };
        _this.showAlertDialog = false;
        _this.alertDialogMessage = '';
        _this.showReCorrectDialog = false;
        _this.showAfterReCorrectDialog = false;
        _this.showStatusChangeDialog = false;
        _this.showAlertFlg = false;
        _this.alertMessage = '';
        _this.alertType = '';
        _this.loading = false;
        /**
         * Login中のSalesForceの UserID
         */
        _this.salesForceUserId = '';
        _this.signInEmail = '';
        /**
         * 価格表リスト
         */
        _this.priceBook2Data = [];
        /**
         * 価格表リスト各プラン別 forEach用
         */
        _this.priceBookDataList = [
            { priceBookName: 'priceBook2DataEntry', priceBookFlg: 'rehabCloudEntry' },
            { priceBookName: 'priceBook2DataBasic', priceBookFlg: 'rehabCloudBasic' },
            { priceBookName: 'priceBook2DataMedium', priceBookFlg: 'rehabCloudMedium' },
            { priceBookName: 'priceBook2DataOldStandard', priceBookFlg: 'rehabCloudStandardOld' },
            { priceBookName: 'priceBook2DataStandard', priceBookFlg: 'rehabCloudStandard' },
            { priceBookName: 'priceBook2DataProfessional', priceBookFlg: 'rehabCloudProfessional' },
            { priceBookName: 'priceBook2DataAdditionalTablet', priceBookFlg: 'rehabCloudTablet' },
            { priceBookName: 'priceBook2DataMotionAi', priceBookFlg: 'rehabCloudMotionAI' },
            { priceBookName: 'priceBook2DataUpgrade', priceBookFlg: 'rehabCloudUpGrade' }
        ];
        /**
         * 価格表リスト各プラン別
         */
        _this.priceBook2DataEntry = [];
        _this.priceBook2DataBasic = [];
        _this.priceBook2DataMedium = [];
        _this.priceBook2DataOldStandard = [];
        _this.priceBook2DataStandard = [];
        _this.priceBook2DataProfessional = [];
        _this.priceBook2DataAdditionalTablet = [];
        _this.priceBook2DataMotionAi = [];
        _this.priceBook2DataUpgrade = [];
        return _this;
    }
    ReflectSalesForce_1 = ReflectSalesForce;
    ReflectSalesForce.prototype.dialogClose = function () {
        this.showStatusChangeDialog = false;
        this.showAlertDialog = false;
        this.showReCorrectDialog = false;
        this.showAfterReCorrectDialog = false;
    };
    ReflectSalesForce.prototype.movePage = function () {
        var routeData = this.$router.resolve({ path: "/update/" + this.getDocumentId_() });
        window.open(routeData.href, '_blank');
        this.dialogClose();
    };
    ReflectSalesForce.prototype.reCorrect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, url_, authToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        self_.dialogClose();
                        self_.startLoading();
                        url_ = self_.$invokeUrlMaker.create('recorrect');
                        return [4 /*yield*/, this.getAuthToken()];
                    case 1:
                        authToken = _a.sent();
                        if (!authToken) {
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        axios_1.default.post(url_, JSON.stringify({
                            documentId: self_.documentData.documentId
                        }), {
                            headers: {
                                Authorization: "Bearer " + authToken
                            }
                        }).then(function (res) {
                            self_.endLoading();
                            self_.showAfterReCorrectDialog = true;
                        }).catch(function (e) {
                            console.log(e);
                            self_.endLoading();
                            self_.showAlertDialog = true;
                            self_.alertDialogMessage = self_.$t('view.sales_force.reflect.msg.re_collect_error').toString();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 過去の地続きの商談のekyc情報を取得し、対象の商談を更新する
     */
    ReflectSalesForce.prototype.applyReuseEkycRecord = function (prevOpportunityId, opportunityId) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __awaiter(this, void 0, void 0, function () {
            var self_, result, _l, _m, _o, _p, _q, _r, error_1, reflectSfOpportunityData, url, _s, _t, _u, _v, _w, _x, error_2;
            return __generator(this, function (_y) {
                switch (_y.label) {
                    case 0:
                        self_ = this;
                        _y.label = 1;
                    case 1:
                        _y.trys.push([1, 4, , 5]);
                        _m = (_l = axios_1.default).get;
                        _o = [this.$invokeUrlMaker.create("sales_force/get_approved_ekyc/" + prevOpportunityId)];
                        _p = {};
                        _q = {};
                        _r = "Bearer ";
                        return [4 /*yield*/, self_.getAuthToken()];
                    case 2: return [4 /*yield*/, _m.apply(_l, _o.concat([(_p.headers = (_q.Authorization = _r + (_y.sent()),
                                _q),
                                _p)]))];
                    case 3:
                        result = _y.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _y.sent();
                        console.error("ekyc\u306E\u60C5\u5831\u53D6\u5F97\u9014\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u8A73\u7D30: " + error_1);
                        throw error_1;
                    case 5:
                        reflectSfOpportunityData = {
                            "EkycVerificationAt": ((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.alreadyEkyc) === null || _b === void 0 ? void 0 : _b.EkycVerificationAt) || '',
                            "PersonalEkycVerificationId": ((_d = (_c = result.data) === null || _c === void 0 ? void 0 : _c.alreadyEkyc) === null || _d === void 0 ? void 0 : _d.PersonalEkycVerificationId) || '',
                            "PersonalEkycVerificationStatus": ((_f = (_e = result.data) === null || _e === void 0 ? void 0 : _e.alreadyEkyc) === null || _f === void 0 ? void 0 : _f.PersonalEkycVerificationStatus) || '',
                            "PersonalIdentityVerificationByOfficialId": ((_h = (_g = result.data) === null || _g === void 0 ? void 0 : _g.alreadyEkyc) === null || _h === void 0 ? void 0 : _h.PersonalIdentityVerificationByOfficialId) || '',
                            "PersonalIdentityVerificationBySelfie": ((_k = (_j = result.data) === null || _j === void 0 ? void 0 : _j.alreadyEkyc) === null || _k === void 0 ? void 0 : _k.PersonalIdentityVerificationBySelfie) || '',
                            "TabletDeliverySkipFlg": "true"
                        };
                        url = this.$invokeUrlMaker.create("sales_force/update_opportunity_with_ekyc/" + opportunityId);
                        _y.label = 6;
                    case 6:
                        _y.trys.push([6, 9, , 10]);
                        _t = (_s = axios_1.default).post;
                        _u = [url,
                            JSON.stringify(reflectSfOpportunityData)];
                        _v = {};
                        _w = {};
                        _x = "Bearer ";
                        return [4 /*yield*/, this.getAuthToken()];
                    case 7: return [4 /*yield*/, _t.apply(_s, _u.concat([(_v.headers = (_w.Authorization = _x + (_y.sent()),
                                _w),
                                _v)]))];
                    case 8:
                        _y.sent();
                        return [3 /*break*/, 10];
                    case 9:
                        error_2 = _y.sent();
                        console.error("\u5546\u8AC7\u3092\u66F4\u65B0\u3059\u308B\u969B\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3002" + error_2);
                        throw error_2;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    ReflectSalesForce.prototype.reCorrectUrlButtonClick = function () {
        this.showReCorrectDialog = true;
    };
    ReflectSalesForce.prototype.parseDate = function (dateStr) {
        return date_parser_1.default.toJapaneseDateStr(dateStr);
    };
    ReflectSalesForce.prototype.showKobetu = function () {
        return this.showService(apply_service_const_1.default.KOBETSU);
    };
    ReflectSalesForce.prototype.showEntry = function () {
        return this.showService(apply_service_const_1.default.ENTRY);
    };
    ReflectSalesForce.prototype.showBasic = function () {
        return this.showService(apply_service_const_1.default.BASIC);
    };
    ReflectSalesForce.prototype.showMedium = function () {
        return this.showService(apply_service_const_1.default.MEDIUM);
    };
    ReflectSalesForce.prototype.showStandard = function () {
        return this.showService(apply_service_const_1.default.STANDARD);
    };
    ReflectSalesForce.prototype.showProfessional = function () {
        return this.showService(apply_service_const_1.default.PROFESSIONAL);
    };
    ReflectSalesForce.prototype.showUpgradeToStandard = function () {
        return this.showService(apply_service_const_1.default.UPGRADE_TO_STANDARD);
    };
    ReflectSalesForce.prototype.showUpgrade = function () {
        return this.showService(apply_service_const_1.default.UPGRADE);
    };
    ReflectSalesForce.prototype.showAdditionalTablet = function () {
        return this.showService(apply_service_const_1.default.ADDITIONAL_TABLET);
    };
    ReflectSalesForce.prototype.showMotionAi = function () {
        return this.showService(apply_service_const_1.default.MOTION_AI);
    };
    ReflectSalesForce.prototype.showOldStandard = function () {
        return this.showService(apply_service_const_1.default.OLD_STANDARD);
    };
    ReflectSalesForce.prototype.showOralCare = function () {
        return this.showService(apply_service_const_1.default.ORAL_CARE);
    };
    ReflectSalesForce.prototype.showService = function (serviceType) {
        return this.documentData.applyInfoApplyService.includes(serviceType);
    };
    ReflectSalesForce.prototype.isLinkComplete = function (columnName) {
        return this.salesForceInfo[columnName] === entity_1.SalesForceStatus.LINKD;
    };
    ReflectSalesForce.prototype.reflect = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, authToken, url_, hasError, hasEkycError, hasReflectIdDataError, notificationMessage, i, reflectType, ekycUrl, ekycRes, res, reflectIdDataUrl_;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        self_.startLoading();
                        Object.keys(data['salesForceInfo']).forEach(function (key) {
                            self_.salesForceInfo[key] = data['salesForceInfo'][key];
                        });
                        return [4 /*yield*/, this.getAuthToken()];
                    case 1:
                        authToken = _a.sent();
                        url_ = this.$invokeUrlMaker.create('sales_force/post');
                        self_.salesForceInfo.lastUpdateUser = this.salesForceUserId;
                        hasError = false;
                        hasEkycError = false;
                        hasReflectIdDataError = false;
                        // 商談商品がすべてSF連携されていない場合、申込内容OBJへの連携を中止する。
                        if (data['reflectType'].indexOf(ReflectType_1.SalesForceReflectType.APPLICATION_DETAILS) !== -1) {
                            notificationMessage = "";
                            notificationMessage = self_.checkingLinkedOpportunity();
                            if (value_checker_1.default.isPresent(notificationMessage)) {
                                notificationMessage += 'すべての商談／商談商品がSF連携されてから申込内容をSFに登録できます。';
                                self_.endLoading();
                                self_.alertDialogMessage = notificationMessage;
                                self_.showAlertDialog = true;
                                return [2 /*return*/];
                            }
                            if (value_checker_1.default.isPresent(self_.salesForceInfo['basicPriceBook2Id'])) {
                                this.getEarliestDateVariable();
                            }
                        }
                        if (!(data['reflectType'].indexOf(ReflectType_1.SalesForceReflectType.OPPORTUNITY_ITEM_ADDITIONAL_TABLET) === -1)) return [3 /*break*/, 10];
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < data['reflectType'].length)) return [3 /*break*/, 9];
                        reflectType = data['reflectType'][i];
                        if (!((reflectType === ReflectType_1.SalesForceReflectType.APPLICATION_DETAILS) &&
                            (apply_service_utils_1.default.isEkycCheck(self_.documentData)) &&
                            (value_checker_1.default.isBlank(self_.salesForceInfo.corporateEkycSkipFlg) || value_checker_1.default.isBlank(self_.salesForceInfo.personalEkycSkipFlg)))) return [3 /*break*/, 4];
                        // 通常の運用上考えられないが、申込内容OBJのIDが空白の場合、警告を出力する。
                        if (value_checker_1.default.isBlank(self_.salesForceInfo['applicationDetailId'])) {
                            self_.alertType = 'warning';
                            self_.alertMessage = '「SalesForceへの申込内容登録」にて初めて申込内容が作成された場合、本人法人確認用メールが連携されませんので、ご了承下さい。';
                            self_.alertMessage += 'メール内容自体は追跡できるので別途、開発にご連絡下さい。';
                            self_.showAlertFlg = true;
                        }
                        ekycUrl = this.$invokeUrlMaker.create('ekyc/post');
                        return [4 /*yield*/, axios_1.default.post(ekycUrl, JSON.stringify({
                                salesForceInfo: self_.salesForceInfo,
                                documentData: self_.documentData
                            }), {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            }).catch(function () {
                                self_.endLoading();
                                self_.alertDialogMessage = '本人・法人確認処理で、エラーが発生しました。。開発に連絡してください！！';
                                self_.showAlertDialog = true;
                                hasEkycError = true;
                            })];
                    case 3:
                        ekycRes = _a.sent();
                        if (ekycRes && ekycRes.status === 500) {
                            self_.alertDialogMessage = "\u672C\u4EBA\u30FB\u6CD5\u4EBA\u78BA\u8A8D\u51E6\u7406\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3002<br>ErrorMessage: " + ekycRes.data['err'];
                            self_.showAlertDialog = true;
                            hasEkycError = true;
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        _a.label = 4;
                    case 4:
                        if (hasEkycError) {
                            return [3 /*break*/, 9];
                        }
                        return [4 /*yield*/, axios_1.default.post(url_, JSON.stringify({
                                salesForceInfo: self_.salesForceInfo,
                                document: self_.documentData,
                                reflectType: reflectType,
                                signInEmail: this.signInEmail
                            }), {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            }).catch(function () {
                                self_.endLoading();
                                self_.alertDialogMessage = 'SalesForce連携で、エラーが発生しました。。開発に連絡してください！！';
                                self_.showAlertDialog = true;
                                hasError = true;
                            })];
                    case 5:
                        res = _a.sent();
                        if (res && res.data['apiResult']['errorMessage']) {
                            self_.alertDialogMessage = "SalesForce\u9023\u643A\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3002<br>ErrorMessage: " + res.data['apiResult']['errorMessage'];
                            self_.showAlertDialog = true;
                            hasError = true;
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        if (hasError) {
                            return [3 /*break*/, 9];
                        }
                        if (!((reflectType === ReflectType_1.SalesForceReflectType.TORIHIKISAKI) && this.isLinkComplete('applicationDetailStatus'))) return [3 /*break*/, 7];
                        reflectIdDataUrl_ = this.$invokeUrlMaker.create('ekyc/reflect_latest_identification_data');
                        return [4 /*yield*/, axios_1.default.post(reflectIdDataUrl_, JSON.stringify({
                                salesForceInfo: self_.salesForceInfo,
                                document: self_.documentData
                            }), {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            }).then(function (res) {
                                self_.alertType = 'info';
                                self_.alertMessage = res.data.msg;
                                self_.showAlertFlg = true;
                            }).catch(function (err) {
                                self_.endLoading();
                                if (err.response.status === 500) {
                                    self_.alertDialogMessage = '本人・法人確認データ反映で、エラーが発生しました。。開発に連絡してください！！';
                                    self_.showAlertDialog = true;
                                    hasReflectIdDataError = true;
                                }
                                else {
                                    self_.alertDialogMessage = '本人・法人確認データ反映で、エラーが発生しました。。開発に連絡してください！！';
                                    self_.showAlertDialog = true;
                                    hasReflectIdDataError = true;
                                }
                            })];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        if (hasReflectIdDataError) {
                            return [3 /*break*/, 9];
                        }
                        self_.salesForceInfo = res.data['salesForceInfo'];
                        _a.label = 8;
                    case 8:
                        i++;
                        return [3 /*break*/, 2];
                    case 9:
                        self_.alertDialogMessage = 'SalesForceに連携しました！';
                        self_.showAlertDialog = true;
                        self_.endLoading();
                        return [3 /*break*/, 16];
                    case 10:
                        if (!!self_.salesForceInfo.additionalTabletRegisterObj.length) return [3 /*break*/, 12];
                        return [4 /*yield*/, self_.registerAdditionalTablets(authToken, data)];
                    case 11:
                        _a.sent();
                        return [3 /*break*/, 16];
                    case 12:
                        if (!(self_.salesForceInfo.additionalTabletRegisterObj.length &&
                            self_.salesForceInfo.additionalTabletRegisterObj.length !== parseInt(self_.salesForceInfo.additionalTablets))) return [3 /*break*/, 14];
                        return [4 /*yield*/, self_.reRegisterAdditionalTablets(authToken, data)];
                    case 13:
                        _a.sent();
                        return [3 /*break*/, 16];
                    case 14:
                        if (!(self_.salesForceInfo.additionalTabletRegisterObj.length)) return [3 /*break*/, 16];
                        return [4 /*yield*/, self_.updateAdditionalTablets(authToken, data)];
                    case 15:
                        _a.sent();
                        _a.label = 16;
                    case 16: return [2 /*return*/];
                }
            });
        });
    };
    ReflectSalesForce.prototype.registerAdditionalTablets = function (authToken, data) {
        return __awaiter(this, void 0, void 0, function () {
            var tablets, tmpDataObj, evacuationAdditionalTabletName, hasError, self_, y, firstTabletName, x, reflectType, res, i, reflectType, res, expectedTabletCount, actualRegisteredTabletCount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tablets = 0;
                        tmpDataObj = {};
                        evacuationAdditionalTabletName = '';
                        hasError = false;
                        self_ = this;
                        if (value_checker_1.default.isPresent(self_.salesForceInfo.additionalTablets)) {
                            tablets = parseInt(self_.salesForceInfo.additionalTablets);
                        }
                        else {
                            self_.alertDialogMessage = "\u30BF\u30D6\u30EC\u30C3\u30C8\u306E\u53F0\u6570\u304C0\u53F0\u3067\u3059\uFF01\uFF01\u51E6\u7406\u3092\u4E2D\u65AD\u3057\u307E\u3059\uFF01\uFF01";
                            self_.showAlertDialog = true;
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        y = 0;
                        _a.label = 1;
                    case 1:
                        if (!(y < tablets)) return [3 /*break*/, 11];
                        if (!(y === 0 && value_checker_1.default.isPresent(self_.salesForceInfo.opportunityAdditionalTabletId) &&
                            !apply_service_utils_1.default.isMainPlanCheck(self_.documentData) && !apply_service_utils_1.default.isOptionalPlanCheck(self_.documentData))) return [3 /*break*/, 6];
                        evacuationAdditionalTabletName = self_.salesForceInfo.opportunityAdditionalTabletName;
                        firstTabletName = self_.salesForceInfo.opportunityAdditionalTabletName.slice(0, -11) + "_\u8FFD\u52A0\u30BF\u30D6\u30EC\u30C3\u30C8_1\u53F0\u76EE_" + self_.formatDate(new Date());
                        self_.salesForceInfo.opportunityAdditionalTabletName = firstTabletName;
                        x = 0;
                        _a.label = 2;
                    case 2:
                        if (!(x < data.reflectType.length)) return [3 /*break*/, 5];
                        self_.salesForceInfo.firstTabletRegister = x === 0 ? '0' : '1';
                        reflectType = data.reflectType[x];
                        return [4 /*yield*/, self_.sendSalesForcePostRequest(authToken, reflectType)];
                    case 3:
                        res = _a.sent();
                        if (res && res.data.apiResult.errorMessage) {
                            self_.alertDialogMessage = "SalesForce\u9023\u643A\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3002<br>ErrorMessage: " + res.data.apiResult.errorMessage;
                            self_.showAlertDialog = true;
                            hasError = true;
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        if (hasError)
                            return [3 /*break*/, 5];
                        if (res && res.data) {
                            self_.salesForceInfo = res.data.salesForceInfo;
                        }
                        if (x === 2) {
                            tmpDataObj = self_.createTabletTmpDataObj();
                            self_.salesForceInfo.additionalTabletRegisterObj.push(tmpDataObj);
                        }
                        _a.label = 4;
                    case 4:
                        x++;
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 10];
                    case 6:
                        if (y === 0 && (apply_service_utils_1.default.isMainPlanCheck(self_.documentData) || apply_service_utils_1.default.isOptionalPlanCheck(self_.documentData))) {
                            evacuationAdditionalTabletName = self_.salesForceInfo.opportunityAdditionalTabletName;
                            self_.initializeTabletInfo();
                        }
                        if (y >= 1) {
                            self_.updateMultipleTabletInfo(y, evacuationAdditionalTabletName);
                        }
                        i = 0;
                        _a.label = 7;
                    case 7:
                        if (!(i < data.reflectType.length)) return [3 /*break*/, 10];
                        self_.salesForceInfo.firstTabletRegister = '1';
                        reflectType = data.reflectType[i];
                        return [4 /*yield*/, self_.sendSalesForcePostRequest(authToken, reflectType)];
                    case 8:
                        res = _a.sent();
                        if (res && res.data.apiResult.errorMessage) {
                            self_.alertDialogMessage = "SalesForce\u9023\u643A\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3002<br>ErrorMessage: " + res.data.apiResult.errorMessage;
                            self_.showAlertDialog = true;
                            hasError = true;
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        if (hasError)
                            return [3 /*break*/, 10];
                        if (res && res.data) {
                            self_.salesForceInfo = res.data.salesForceInfo;
                        }
                        if (i === 2) {
                            self_.salesForceInfo.opportunityAdditionalTabletName += self_.formatDate(new Date());
                            tmpDataObj = self_.createTabletTmpDataObj();
                            self_.salesForceInfo.additionalTabletRegisterObj.push(tmpDataObj);
                        }
                        _a.label = 9;
                    case 9:
                        i++;
                        return [3 /*break*/, 7];
                    case 10:
                        y++;
                        return [3 /*break*/, 1];
                    case 11: return [4 /*yield*/, self_.updateAdditionalTabletSalesInfo(authToken, self_.salesForceInfo, self_.signInEmail)];
                    case 12:
                        _a.sent();
                        // Salesforceへのリクエストが途中までしか実行されず、予定台数分が登録されていない場合、エラーメッセージを出力する。
                        if (self_.salesForceInfo.additionalTabletRegisterObj.length &&
                            self_.salesForceInfo.additionalTabletRegisterObj.length !== parseInt(self_.salesForceInfo.additionalTablets)) {
                            expectedTabletCount = parseInt(self_.salesForceInfo.additionalTablets);
                            actualRegisteredTabletCount = self_.salesForceInfo.additionalTabletRegisterObj.length;
                            self_.alertDialogMessage = "\u30A8\u30E9\u30FC\u767A\u751F\uFF01\uFF01<br>";
                            self_.alertDialogMessage += expectedTabletCount + "\u53F0\u5206\u30BF\u30D6\u30EC\u30C3\u30C8\u5546\u8AC7\u304C\u4F5C\u6210\u3055\u308C\u308B\u3079\u304D\u3067\u3057\u305F\u304C\u3001<br>";
                            self_.alertDialogMessage += "\u5B9F\u969B\u306B\u4F5C\u6210\u3055\u308C\u305F\u30BF\u30D6\u30EC\u30C3\u30C8\u5546\u8AC7\u306F" + actualRegisteredTabletCount + "\u53F0\u5206\u3067\u3057\u305F\u3002<br>";
                            self_.alertDialogMessage += "\u3082\u3046\u4E00\u5EA6\u300CSALESFORCE\u306B\u767B\u9332\u3059\u308B\u300D\u30DC\u30BF\u30F3\u3092\u62BC\u4E0B\u3057\u3066\u4E0B\u3055\u3044\u3002";
                            self_.showAlertDialog = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ReflectSalesForce.prototype.sendSalesForcePostRequest = function (authToken, reflectType) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, url_;
            return __generator(this, function (_a) {
                self_ = this;
                url_ = self_.$invokeUrlMaker.create('sales_force/post');
                return [2 /*return*/, axios_1.default.post(url_, JSON.stringify({
                        salesForceInfo: self_.salesForceInfo,
                        document: self_.documentData,
                        reflectType: reflectType,
                        signInEmail: self_.signInEmail
                    }), {
                        headers: {
                            Authorization: "Bearer " + authToken
                        }
                    }).catch(function () {
                        self_.endLoading();
                        self_.alertDialogMessage = 'SalesForce連携で、エラーが発生しました。。開発に連絡してください！！';
                        self_.showAlertDialog = true;
                    })];
            });
        });
    };
    ReflectSalesForce.prototype.createTabletTmpDataObj = function () {
        var self_ = this;
        return {
            opportunityName: self_.salesForceInfo.opportunityAdditionalTabletName,
            opportunityId: self_.salesForceInfo.opportunityAdditionalTabletId,
            opportunityLineItemsId: self_.salesForceInfo.opportunityAdditionalTabletItemId,
            opportunityLineItemsInitialFeeId: self_.salesForceInfo.opportunityAdditionalTabletItemInitialFeeId
        };
    };
    ReflectSalesForce.prototype.initializeTabletInfo = function () {
        var self_ = this;
        self_.salesForceInfo.opportunityAdditionalTabletItemId = '';
        // 2台目以降はupdateMultipleTabletInfoにて台数に応じた商談名がSETされる
        var initialTabletName = self_.salesForceInfo.opportunityAdditionalTabletName.slice(0, -11) + "_\u8FFD\u52A0\u30BF\u30D6\u30EC\u30C3\u30C8_1\u53F0\u76EE_";
        self_.salesForceInfo.opportunityAdditionalTabletName = initialTabletName;
        self_.salesForceInfo.opportunityAdditionalTabletId = '';
    };
    ReflectSalesForce.prototype.updateMultipleTabletInfo = function (y, evacuationAdditionalTabletName) {
        var self_ = this;
        var tabletNum = y;
        var multipleTabletName = evacuationAdditionalTabletName.slice(0, -11);
        multipleTabletName += "_\u8FFD\u52A0\u30BF\u30D6\u30EC\u30C3\u30C8_" + (tabletNum + 1) + "\u53F0\u76EE_";
        self_.salesForceInfo.opportunityAdditionalTabletName = multipleTabletName;
        self_.salesForceInfo.opportunityAdditionalTabletId = '';
        self_.salesForceInfo.opportunityAdditionalTabletItemId = '';
        self_.salesForceInfo.opportunityAdditionalTabletItemInitialFeeId = '';
    };
    ReflectSalesForce.prototype.updateAdditionalTablets = function (authToken, data) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, hasError, y, i, reflectType, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        hasError = false;
                        y = 0;
                        _a.label = 1;
                    case 1:
                        if (!(y < self_.salesForceInfo.additionalTabletRegisterObj.length)) return [3 /*break*/, 6];
                        // タブレットを登録した配列の何番目かを特定し、代入する。
                        self_.salesForceInfo.opportunityAdditionalTabletId = self_.salesForceInfo.additionalTabletRegisterObj[y]['opportunityId'];
                        self_.salesForceInfo.opportunityAdditionalTabletName = self_.salesForceInfo.additionalTabletRegisterObj[y]['opportunityName'];
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < data['reflectType'].length)) return [3 /*break*/, 5];
                        self_.salesForceInfo.firstTabletRegister = '0';
                        reflectType = data['reflectType'][i];
                        if (!(reflectType === ReflectType_1.SalesForceReflectType.OPPORTUNITY_ADDITIONAL_TABLET)) return [3 /*break*/, 4];
                        return [4 /*yield*/, self_.sendSalesForcePostRequest(authToken, reflectType)];
                    case 3:
                        res = _a.sent();
                        if (res && res.data.apiResult.errorMessage) {
                            self_.alertDialogMessage = "SalesForce\u9023\u643A\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3002<br>ErrorMessage: " + res.data.apiResult.errorMessage;
                            self_.showAlertDialog = true;
                            hasError = true;
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        if (hasError)
                            return [3 /*break*/, 5];
                        if (res && res.data) {
                            self_.salesForceInfo = res.data.salesForceInfo;
                        }
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5:
                        y++;
                        return [3 /*break*/, 1];
                    case 6: // ループの終わり タブレット台数分
                    return [4 /*yield*/, self_.updateAdditionalTabletSalesInfo(authToken, self_.salesForceInfo, self_.signInEmail)];
                    case 7:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReflectSalesForce.prototype.updateAdditionalTabletSalesInfo = function (authToken, salesForceInfo, signInEmail) {
        return __awaiter(this, void 0, void 0, function () {
            var updateAdditionalTabletUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        updateAdditionalTabletUrl = this.$invokeUrlMaker.create('sales_force/tablet_obj_update');
                        return [4 /*yield*/, axios_1.default.post(updateAdditionalTabletUrl, JSON.stringify({
                                salesForceInfo: salesForceInfo,
                                signInEmail: signInEmail
                            }), {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            }).catch(function () {
                                this.endLoading();
                                this.alertDialogMessage = 'SalesForce連携で、エラーが発生しました。。開発に連絡してください！！';
                                this.alertDialogMessage += 'このERRORは追加タブレットの更新時に発生しています。';
                                this.showAlertDialog = true;
                            }.bind(this))];
                    case 1:
                        _a.sent();
                        this.alertDialogMessage = 'SalesForceに連携しました！';
                        this.showAlertDialog = true;
                        this.endLoading();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReflectSalesForce.prototype.getStatusChangeMsg = function () {
        if (this.isLinkComplete('salesForceStatus')) {
            return this.$t('view.sales_force.reflect.msg.change_status_mirenkei');
        }
        return this.$t('view.sales_force.reflect.msg.change_status_renkeizumi');
    };
    ReflectSalesForce.prototype.reRegisterAdditionalTablets = function (authToken, data) {
        return __awaiter(this, void 0, void 0, function () {
            var expectedTabletCount, diffTablets, currentRegistrationCount, tmpDataObj, evacuationAdditionalTabletName, hasError, self_, y, i, reflectType, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        expectedTabletCount = 0;
                        diffTablets = 0;
                        currentRegistrationCount = 0;
                        tmpDataObj = {};
                        evacuationAdditionalTabletName = '';
                        hasError = false;
                        self_ = this;
                        // 不足しているタブレットの台数を求める
                        expectedTabletCount = parseInt(self_.salesForceInfo.additionalTablets);
                        currentRegistrationCount = self_.salesForceInfo.additionalTabletRegisterObj.length;
                        diffTablets = expectedTabletCount - currentRegistrationCount;
                        // 商談名を取得（_追加タブレット_n台目_yyyy-mm-ddを除去）
                        evacuationAdditionalTabletName = self_.salesForceInfo.additionalTabletRegisterObj[0].opportunityName.slice(0, -23);
                        y = 0;
                        _a.label = 1;
                    case 1:
                        if (!(y < diffTablets)) return [3 /*break*/, 6];
                        // タブレット関係の各IDを初期化（レコード新規作成のため）
                        self_.salesForceInfo.opportunityAdditionalTabletId = '';
                        self_.salesForceInfo.opportunityAdditionalTabletItemId = '';
                        self_.salesForceInfo.opportunityAdditionalTabletItemInitialFeeId = '';
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < data.reflectType.length)) return [3 /*break*/, 5];
                        // 商談名を設定
                        self_.salesForceInfo.opportunityAdditionalTabletName = evacuationAdditionalTabletName + ("_\u8FFD\u52A0\u30BF\u30D6\u30EC\u30C3\u30C8_" + (currentRegistrationCount + y + 1) + "\u53F0\u76EE_");
                        // n台分新規登録のため、firstTabletRegisterを'1'に設定
                        self_.salesForceInfo.firstTabletRegister = '1';
                        reflectType = data.reflectType[i];
                        return [4 /*yield*/, self_.sendSalesForcePostRequest(authToken, reflectType)];
                    case 3:
                        res = _a.sent();
                        if (res && res.data.apiResult.errorMessage) {
                            self_.alertDialogMessage = "SalesForce\u9023\u643A\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3002<br>ErrorMessage: " + res.data.apiResult.errorMessage;
                            self_.showAlertDialog = true;
                            hasError = true;
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        if (hasError)
                            return [3 /*break*/, 5];
                        if (res && res.data) {
                            self_.salesForceInfo = res.data.salesForceInfo;
                        }
                        if (i === 2) {
                            self_.salesForceInfo.opportunityAdditionalTabletName += self_.formatDate(new Date());
                            tmpDataObj = self_.createTabletTmpDataObj();
                            self_.salesForceInfo.additionalTabletRegisterObj.push(tmpDataObj);
                        }
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5:
                        y++;
                        return [3 /*break*/, 1];
                    case 6: return [4 /*yield*/, self_.updateAdditionalTabletSalesInfo(authToken, self_.salesForceInfo, self_.signInEmail)];
                    case 7:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReflectSalesForce.prototype.changeSalesForceStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, changeStatus, authToken, url_;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        self_.startLoading();
                        this.showStatusChangeDialog = false;
                        changeStatus = entity_1.SalesForceStatus.LINKD;
                        if (this.isLinkComplete('salesForceStatus')) {
                            changeStatus = entity_1.SalesForceStatus.NOT_LINK;
                        }
                        return [4 /*yield*/, this.getAuthToken()];
                    case 1:
                        authToken = _a.sent();
                        url_ = this.$invokeUrlMaker.create('sales_force/status/update');
                        axios_1.default.post(url_, JSON.stringify({
                            salesForceInfo: this.salesForceInfo,
                            status: changeStatus
                        }), {
                            headers: {
                                Authorization: "Bearer " + authToken
                            }
                        }).then(function (res) {
                            self_.endLoading();
                            self_.salesForceInfo = res.data['salesForceInfo'];
                            self_.alertDialogMessage = 'SalesForce連携ステータスを更新しました！';
                            self_.showAlertDialog = true;
                        }).catch(function (err) {
                            self_.endLoading();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
       必要な商談／商談商品がSF連携されているかチェックする。
       なされていない場合、申込内容OBへの連携はできない。
     */
    ReflectSalesForce.prototype.checkingLinkedOpportunity = function () {
        var notLinkedMessage = '';
        if (this.showEntry()) {
            if (!this.isLinkComplete('opportunityEntryStatus') ||
                !this.isLinkComplete('opportunityEntryItemStatus')) {
                notLinkedMessage += '■EntryがSF連携されていません。';
                notLinkedMessage += '</br>';
            }
        }
        if (this.showBasic()) {
            if (!this.isLinkComplete('opportunityBasicStatus') ||
                !this.isLinkComplete('opportunityBasicItemStatus')) {
                notLinkedMessage += '■BasicがSF連携されていません。';
                notLinkedMessage += '</br>';
            }
        }
        if (this.showMedium()) {
            if (!this.isLinkComplete('opportunityMediumStatus') ||
                !this.isLinkComplete('opportunityMediumItemStatus')) {
                notLinkedMessage += '■MediumがSF連携されていません。';
                notLinkedMessage += '</br>';
            }
        }
        if (this.showStandard()) {
            if (!this.isLinkComplete('opportunityStandardStatus') ||
                !this.isLinkComplete('opportunityStandardItemStatus')) {
                notLinkedMessage += '■StandardがSF連携されていません。';
                notLinkedMessage += '</br>';
            }
        }
        if (this.showProfessional()) {
            if (!this.isLinkComplete('opportunityProfessionalStatus') ||
                !this.isLinkComplete('opportunityProfessionalItemStatus')) {
                notLinkedMessage += '■ProfessionalがSF連携されていません。';
                notLinkedMessage += '</br>';
            }
        }
        // if (this.showUpgradeToStandard()) {
        //     if (!this.isLinkComplete('opportunityStandardStatus') ||
        //        !this.isLinkComplete('opportunityStandardItemStatus')
        //     ) {
        //         notLinkedMessage += '■UpgradeがSF連携されていません。';
        //         notLinkedMessage += '</br>';
        //     }
        // }
        if (this.showUpgrade()) {
            if (!this.isLinkComplete('opportunityToUpgradeStatus') ||
                !this.isLinkComplete('opportunityToUpgradeItemStatus')) {
                notLinkedMessage += '■アップグレードがSF連携されていません。';
                notLinkedMessage += '</br>';
            }
        }
        if (this.showAdditionalTablet()) {
            if (!this.isLinkComplete('opportunityAdditionalTabletStatus') ||
                !this.isLinkComplete('opportunityAdditionalTabletItemStatus')) {
                notLinkedMessage += '■タブレットがSF連携されていません。';
                notLinkedMessage += '</br>';
            }
        }
        if (this.showMotionAi()) {
            if (!this.isLinkComplete('opportunityMotionAiStatus') ||
                !this.isLinkComplete('opportunityMotionAiItemStatus')) {
                notLinkedMessage += '■モーションAIがSF連携されていません。';
                notLinkedMessage += '</br>';
            }
        }
        if (this.showOldStandard()) {
            if (!this.isLinkComplete('opportunityOldStandardStatus') ||
                !this.isLinkComplete('opportunityOldStandardItemStatus')) {
                notLinkedMessage += '■Standard（旧）がSF連携されていません。';
                notLinkedMessage += '</br>';
            }
        }
        return notLinkedMessage;
    };
    ReflectSalesForce.prototype.getEarliestDateVariable = function () {
        var compareArray = [];
        var earliestPropertyName = "";
        if (value_checker_1.default.isPresent(this.salesForceInfo.applyInfoEntryStartDate)) {
            compareArray.push({ entry: "'" + this.salesForceInfo.applyInfoEntryStartDate + "'" });
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.applyInfoOldStandardStartDate)) {
            compareArray.push({ oldStandard: "'" + this.salesForceInfo.applyInfoOldStandardStartDate + "'" });
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.applyInfoMediumStartDate)) {
            compareArray.push({ medium: "'" + this.salesForceInfo.applyInfoMediumStartDate + "'" });
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.applyInfoStandardStartDate)) {
            compareArray.push({ standard: "'" + this.salesForceInfo.applyInfoStandardStartDate + "'" });
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.applyInfoProfessionalStartDate)) {
            compareArray.push({ professional: "'" + this.salesForceInfo.applyInfoProfessionalStartDate + "'" });
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.toUpgradeStartDate)) {
            compareArray.push({ toUpgrade: "'" + this.salesForceInfo.toUpgradeStartDate + "'" });
        }
        var earliestProperty = function (objects) {
            var earliestDate = null;
            var earliestPropertyName = null;
            objects.forEach(function (obj) {
                for (var propName in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, propName)) {
                        var currentDate = dayjs_1.default(obj[propName]);
                        if (!earliestDate || currentDate.isBefore(earliestDate)) {
                            earliestDate = currentDate;
                            earliestPropertyName = propName;
                        }
                    }
                }
            });
            return earliestPropertyName;
        };
        earliestPropertyName = earliestProperty(compareArray);
        switch (earliestPropertyName) {
            case 'entry':
                this.salesForceInfo.entryPrimaryEkycIdFlg = 'true';
                break;
            case 'oldStandard':
                this.salesForceInfo.oldStandardPrimaryEkycIdFlg = 'true';
                break;
            case 'medium':
                this.salesForceInfo.mediumPrimaryEkycIdFlg = 'true';
                break;
            case 'standard':
                this.salesForceInfo.standardPrimaryEkycIdFlg = 'true';
                break;
            case 'professional':
                this.salesForceInfo.professionalPrimaryEkycIdFlg = 'true';
                break;
            case 'toUpgrade':
                this.salesForceInfo.upgradePrimaryEkycIdFlg = 'true';
                break;
        }
    };
    ReflectSalesForce.prototype.csvOutput = function (reflectType) {
        var csvOutputModule = csv_output_module_factory_1.default.create(reflectType);
        csvOutputModule.export(this.documentData, this.salesForceInfo);
    };
    ReflectSalesForce.prototype.getAuthToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$cognito.authToken()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ReflectSalesForce.prototype.startLoading = function () {
        this.loading = true;
    };
    ReflectSalesForce.prototype.endLoading = function () {
        this.loading = false;
    };
    ReflectSalesForce.prototype.formatDate = function (dt) {
        var y = dt.getFullYear();
        var m = ('00' + (dt.getMonth() + 1)).slice(-2);
        var d = ('00' + dt.getDate()).slice(-2);
        return (y + '-' + m + '-' + d);
    };
    ReflectSalesForce.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, documentId, authToken, _a, getDocumentUrl, documentData, getUserUrl, userData, getPriceBook2Url, priceBook2Data;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        self_ = this;
                        this.$emit('title-change', this.$t('view.sales_force.reflect.titles.after'));
                        self_.startLoading();
                        this.$cognito.setLoginCode(this.$route.query['code']);
                        documentId = this.getDocumentId_();
                        if (documentId) {
                            this.setDocumentId_(documentId);
                        }
                        return [4 /*yield*/, this.getAuthToken()];
                    case 1:
                        authToken = _b.sent();
                        if (!authToken) {
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.$cognito.getUserEmail()];
                    case 2:
                        _a.signInEmail = _b.sent();
                        this.documentData.documentId = documentId;
                        this.salesForceInfo.documentId = documentId;
                        getDocumentUrl = this.$invokeUrlMaker.create("get/admin/" + documentId);
                        return [4 /*yield*/, axios_1.default.get(getDocumentUrl, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            }).catch(function (e) {
                                self_.endLoading();
                                self_.$router.push({ path: '/' });
                            })];
                    case 3:
                        documentData = _b.sent();
                        if (!documentData) {
                            return [2 /*return*/];
                        }
                        if (documentData.data['salesForce']) {
                            self_.salesForceInfo = documentData.data['salesForce'];
                        }
                        if (documentData.data['document']) {
                            self_.documentData = documentData.data['document'];
                        }
                        getUserUrl = this.$invokeUrlMaker.create('sales_force/get_user');
                        return [4 /*yield*/, axios_1.default.post(getUserUrl, JSON.stringify({
                                email: this.signInEmail
                            }), {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            }).catch(function () {
                                self_.endLoading();
                                self_.$router.push({ path: '/' });
                            })];
                    case 4:
                        userData = _b.sent();
                        self_.endLoading();
                        if (!userData) {
                            return [2 /*return*/];
                        }
                        this.salesForceUserId = userData.data['userId'];
                        getPriceBook2Url = this.$invokeUrlMaker.create('sales_force/get_pricebook2');
                        return [4 /*yield*/, axios_1.default.get(getPriceBook2Url, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            })];
                    case 5:
                        priceBook2Data = _b.sent();
                        this.priceBook2Data = priceBook2Data.data['priceBookList'];
                        this.priceBookDataList.forEach(function (priceBookData) {
                            _this[priceBookData.priceBookName] = _this.priceBook2Data.filter(function (item) {
                                return item[priceBookData.priceBookFlg] === true;
                            });
                            _this[priceBookData.priceBookName].unshift({
                                value: '',
                                text: _this.$t('dictionary.select.default_text'),
                                IsStandard: '',
                                Description: ''
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ReflectSalesForce.prototype.getDocumentId_ = function () {
        if (this.$route.params['documentId']) {
            return this.$route.params['documentId'];
        }
        try {
            return localStorage.getItem(ReflectSalesForce_1.LOCAL_STORAGE_KEY);
        }
        catch (e) {
        }
    };
    ReflectSalesForce.prototype.setDocumentId_ = function (documentId) {
        try {
            localStorage.setItem(ReflectSalesForce_1.LOCAL_STORAGE_KEY, documentId);
        }
        catch (e) {
        }
    };
    ReflectSalesForce.prototype.fetchSalesForceInfo = function (data) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var self_, authToken, url_, result, isSequentialContractStateSatisfied, isAlreadyEkycLatestRecordValid, previousOpportunityId, opportunityId, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        self_ = this;
                        self_.startLoading();
                        return [4 /*yield*/, this.getAuthToken()];
                    case 1:
                        authToken = _b.sent();
                        url_ = this.$invokeUrlMaker.create('sales_force/get');
                        console.log(data);
                        return [4 /*yield*/, axios_1.default.post(url_, JSON.stringify({
                                salesForceInfo: data['salesForceInfo'],
                                fetchTypes: data['fetchTypes']
                            }), {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            }).catch(function () {
                                self_.endLoading();
                                self_.alertDialogMessage = 'SalesForce連携で、エラーが発生しました。。開発に連絡してください！！';
                                self_.showAlertDialog = true;
                                return {};
                            })];
                    case 2:
                        result = _b.sent();
                        if (result['data']['apiResult']['errorMessage']) {
                            self_.endLoading();
                            self_.alertDialogMessage = "SalesForce\u60C5\u5831\u306E\u53D6\u5F97\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3002<br>ErrorMessage: " + result['data']['apiResult']['errorMessage'];
                            self_.showAlertDialog = true;
                            return [2 /*return*/, {}];
                        }
                        isSequentialContractStateSatisfied = self_.salesForceInfo.isSequentialContractState === "true";
                        isAlreadyEkycLatestRecordValid = self_.salesForceInfo.alreadyEkycLatestRecord;
                        if (!isSequentialContractStateSatisfied) return [3 /*break*/, 9];
                        if (!isAlreadyEkycLatestRecordValid) return [3 /*break*/, 7];
                        console.log("\u5951\u7D04\u304C\u5730\u7D9A\u304D\u3067\u304B\u3064alreadyEkycLatestRecord\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u51E6\u7406\u3092\u7D99\u7D9A");
                        previousOpportunityId = (_a = self_.salesForceInfo.alreadyEkycLatestRecord) === null || _a === void 0 ? void 0 : _a.lineItemOpportunityId;
                        opportunityId = self_.salesForceInfo.opportunityId;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        console.debug("\u524D\u56DE\u306E\u5546\u8AC7ID: " + previousOpportunityId + " \u66F4\u65B0\u5148\u306E\u5546\u8AC7ID: " + opportunityId);
                        return [4 /*yield*/, self_.applyReuseEkycRecord(previousOpportunityId, opportunityId)];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_3 = _b.sent();
                        console.error('本人確認IDの引き継ぎ処理中にエラーが発生しました。エラー詳細:', error_3);
                        self_.alertDialogMessage = "SalesForce\u60C5\u5831\u306E\u672C\u4EBA\u78BA\u8A8D\u5F15\u304D\u7D99\u304E\u51E6\u7406\u5B9F\u65BD\u4E2D\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002 <br>ErrorMessage: " + error_3;
                        self_.showAlertDialog = true;
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        console.log("alreadyEkycLatestRecord\u304C\u30BB\u30C3\u30C8\u3055\u308C\u3066\u306A\u3044\u305F\u3081\u3001\u672C\u4EBA\u78BA\u8A8DID\u306E\u5F15\u304D\u7D99\u304E\u51E6\u7406\u306F\u30B9\u30AD\u30C3\u30D7\u3057\u307E\u3059\u3002");
                        _b.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        console.log("\u5730\u7D9A\u304D\u30D5\u30E9\u30B0\u304Cfalse\u306E\u305F\u3081\u3001\u672C\u4EBA\u78BA\u8A8DID\u306E\u5F15\u304D\u7D99\u304E\u51E6\u7406\u306F\u30B9\u30AD\u30C3\u30D7\u3057\u307E\u3059\u3002");
                        _b.label = 10;
                    case 10:
                        // 地続きフラグの処理一連が完了した後にローディングを終了する。
                        self_.endLoading();
                        return [2 /*return*/, result['data']['apiResult']];
                }
            });
        });
    };
    Object.defineProperty(ReflectSalesForce, "LOCAL_STORAGE_KEY", {
        get: function () {
            return 'rehaplan.contract_application.sales_force';
        },
        enumerable: true,
        configurable: true
    });
    var ReflectSalesForce_1;
    ReflectSalesForce = ReflectSalesForce_1 = __decorate([
        vue_property_decorator_1.Component({
            components: {
                OpportunityOralCare: OpportunityOralCare_1.default,
                OpportunityKobetu: OpportunityKobetu_1.default,
                OpportunityUpgrade: OpportunityUpgrade_1.default,
                OpportunityEntry: OpportunityEntry_1.default,
                OpportunityBasic: OpportunityBasic_1.default,
                OpportunityMedium: OpportunityMedium_1.default,
                OpportunityStandard: OpportunityStandard_1.default,
                OpportunityProfessional: OpportunityProfessional_1.default,
                OpportunityUpgradeToStandard: OpportunityUpgradeToStandard_1.default,
                OpportunityAdditionalTablet: OpportunityAdditionalTablet_1.default,
                OpportunityMotionAi: OpportunityMotionAi_1.default,
                OpportunityOldStandard: OpportunityOldStandard_1.default,
                ApplicationDetails: ApplicationDetails_1.default,
                PriceBookSelect: PriceBookSelect_1.default,
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                Loading: Loading_1.default,
                SimpleDialog: SimpleDialog_1.default,
                TorihikisakiSekininsyaTanto: TorihikisakiSekininsyaTanto_1.default,
                TorihikisakiSekininsyaApply: TorihikisakiSekininsyaApply_1.default,
                Torihikisaki: Torihikisaki_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], ReflectSalesForce);
    return ReflectSalesForce;
}(vue_property_decorator_1.Vue));
exports.default = ReflectSalesForce;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/sales_force/ReflectSalesForce.vue
// module id = QxpP
// module chunks = 1